const bindings = {
    backspace: ['backspace'],
    copy: ['meta', 'c'],
    copyWin: ['control', 'c'],
    delete: ['delete'],
    escape: ['escape'],
    paste: ['meta', 'v'],
    pasteWin: ['control', 'v']
};

export default bindings;



// WEBPACK FOOTER //
// ./src/view/calendar/components/KeyBindings.js